import { api } from '@/shared/api';
import { AxiosError } from 'axios';

/**
 * 荷物を削除する（紐づけを解除する）
 * @param applicationId - 申し込みID
 * @param luggageQrCode - 荷物QRコード
 * @returns 成功時は空のレスポンス
 */
export const removeLuggage = async (applicationId: string, luggageQrCode: string): Promise<void> => {
    try {
        await api.delete('/applications/{application_id}/luggages/{luggage_qr_code}', {
            path: { application_id: applicationId, luggage_qr_code: luggageQrCode },
        });
    } catch (error) {
        const axiosError = error as AxiosError<{ message?: string }>;
        const message = axiosError.response?.data?.message;

        if (axiosError.response?.status === 403) {
            throw new Error(message);
        }

        if (axiosError.response?.status === 404) {
            if (message?.includes('申し込み')) {
                throw new Error('申し込みデータがありません。');
            } else {
                throw new Error('荷物データがありません。');
            }
        }
        throw new Error('荷物の削除中にエラーが発生しました。');
    }
};
